module.exports = __webpack_public_path__ + "static/media/health.915de226.png";